import type { OperationRuleModels } from "@/api/client/operation-rule"
import {
  categoriesLabel,
  consentLabel,
  designatedLabel,
  limitLabel,
  requestMethodLabel,
} from "./labels"

// 現在値(defaultRule / propertyRules[].operationRule)と履歴1件(operationRuleLogs[])は同じ設定項目を持つ。
export type OperationalRuleSnapshot = Pick<
  OperationRuleModels.OperationRuleList200DefaultRuleOperationRuleLogsItem,
  | "agentCallContractorApproval"
  | "hasDesignatedContractor"
  | "arrangementLimit"
  | "designatedContractors"
>

const Row = ({ label, value }: { label: string; value: string }) => (
  <div className="grid grid-cols-[96px_1fr] gap-2 text-sm">
    <span className="text-xs font-medium text-slate-500 pt-0.5">{label}</span>
    <span className="whitespace-pre-wrap break-words text-slate-800">{value}</span>
  </div>
)

// 運用ルール1件の設定内容を読み取り専用で表示する(履歴ページ・履歴ダイアログ共用)。
export function OperationalRuleSnapshotView({ rule }: { rule: OperationalRuleSnapshot }) {
  const contractors = rule.designatedContractors ?? []

  return (
    <div className="space-y-4">
      <div className="space-y-2 rounded-md bg-slate-50 p-3">
        <Row label="AC業者手配" value={consentLabel(rule)} />
        <Row label="指定業者" value={designatedLabel(rule)} />
        <Row label="手配上限金額" value={limitLabel(rule)} />
      </div>

      {contractors.length > 0 ? (
        <div className="space-y-2">
          <p className="text-sm font-semibold text-slate-600">指定業者</p>
          {contractors.map((contractor, index) => (
            <div
              key={`${index}-${contractor.name}`}
              className="space-y-2 rounded-md border border-slate-200 p-3"
            >
              <p className="text-xs font-semibold text-slate-500">業者 {index + 1}</p>
              <Row label="業者名" value={contractor.name} />
              <Row label="担当者名" value={contractor.contactPerson || "—"} />
              <Row label="カテゴリ" value={categoriesLabel(contractor.categories)} />
              {contractor.otherCategory && (
                <Row label="その他カテゴリ" value={contractor.otherCategory} />
              )}
              <Row label="連絡先" value={contractor.contactInfo} />
              <Row label="依頼方法" value={requestMethodLabel(contractor.requestMethod)} />
              <Row label="住所" value={contractor.address || "—"} />
              <Row label="備考" value={contractor.note || "—"} />
            </div>
          ))}
        </div>
      ) : (
        <p className="rounded-md bg-slate-50 p-3 text-sm text-slate-500">
          指定業者は登録されていません
        </p>
      )}
    </div>
  )
}
